// extracted by mini-css-extract-plugin
export default {"playerWrapper":"VideoPlayer_playerWrapper__vChS2","reactPlayer":"VideoPlayer_reactPlayer__vQIOM","playButton":"VideoPlayer_playButton__s19uu"};